import { Component, Input } from '@angular/core';
import { BannerState, IReportDetails } from '../../driver-background-check.view-models';
import { classColor as resolveClassColor } from '../../driver-background-check.constants';

@Component({
  selector: 'app-bgc-status-banner',
  templateUrl: './bgc-status-banner.component.html',
  styleUrls: ['./bgc-status-banner.component.scss', '../../driver-background-check.component.scss']
})
export class BgcStatusBannerComponent {
  @Input() state: BannerState;
  @Input() reportDetails: IReportDetails;

  classColor(value: string): string {
    return resolveClassColor(value);
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/driver-background-check/components/bgc-status-banner/bgc-status-banner.component.ts